import Home from "../pages/home";
export const Routes = {
    "/": Home,
};
